import { DateTime } from 'luxon'

export class PaymentPlatform {
	public id: number
	public name: string
	public code: string
	public active: boolean
	public createdAt: DateTime
	public updatedAt: DateTime

	constructor(data: {
		id: number
		name: string
		code: string
		active: boolean
		createdAt: DateTime
		updatedAt: DateTime
	}) {
		this.id = data.id
		this.name = data.name
		this.code = data.code
		this.active = data.active
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
	}

	static create(data: Partial<PaymentPlatform>): PaymentPlatform {
		const defaultValues = {
			id: 0,
			name: '',
			code: '',
			active: false,
			createdAt: DateTime.now(),
			updatedAt: DateTime.now(),
		}
		return new PaymentPlatform({ ...defaultValues, ...data })
	}
}
